import React, {PureComponent, Fragment} from 'react';
import {NavBar, Icon, Popover} from 'antd-mobile';
import PropTypes from 'prop-types';
import './index.scss';
import history from './../../utils/history'
import eventProxy from 'react-eventproxy';

var jumpUrlItem = "";
const Item = Popover.Item;

const myImg = src => <img src={`https://gw.alipayobjects.com/zos/rmsportal/${src}.svg`} className="am-icon am-icon-xs"
                          alt=""/>;

class PublicHeader extends PureComponent {

    constructor(props) {
        super(props);

        const {title} = props;
        this.state = {
            title: title
        }

        eventProxy.on("navitem", (object) => {
            console.log('objecteeee', object);
            jumpUrlItem = object;
            this.setState({
                title: object
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        const {title} = nextProps;
        if (title !== this.state.title) {
            this.setState({
                title: title
            })
        }
    }

    onSelect = (opt) => {
        let selected = opt.props.value;
        console.log(selected)
        switch (selected) {
            case "home":
                history.replace("/home");
                return;
            case "myOrder":
                history.replace('/my');
                return;
            default:
                history.replace("/home");
                return;
        }
    };

    componentDidMount() {
    }

    render() {
        const {bgColor, icon, jump, isNoIcon} = this.props;
        const {title} = this.state;

        return (
            <Fragment>
                <NavBar
                    style={{background: "#293581", color: '#FFFFFF'}}
                    mode="light"
                    icon={!isNoIcon ? <Icon type={icon}/> : null}
                    onLeftClick={() => {
                        if (!isNoIcon) {
                            if (jump) {
                                history.push('/home?tab=' + jump);
                            }
                            else {
                                history.go(-1)
                            }
                        }
                    }}
                    // rightContent={
                    //     <Popover mask
                    //              overlayClassName="fortest"
                    //              overlayStyle={{color: 'currentColor'}}
                    //              visible={this.state.visible}
                    //              overlay={[
                    //                  (<Item key="4" value="home" icon={<Icon type="home"/>}
                    //                         data-seed="logId">首页</Item>),
                    //                  (<Item key="5" value="myOrder" icon={<Icon type="user"/>}
                    //                         style={{whiteSpace: 'nowrap'}}>我的订单</Item>)
                    //              ]}
                    //              align={{
                    //                  overflow: {adjustY: 0, adjustX: 0},
                    //                  offset: [-10, 0],
                    //              }}
                    //              onSelect={this.onSelect}
                    //     >
                    //         <div style={{
                    //             height: '100%',
                    //             padding: '0 15px',
                    //             marginRight: '-15px',
                    //             display: 'flex',
                    //             alignItems: 'center',
                    //         }}
                    //         >
                    //             <Icon type="ellipsis"/>
                    //         </div>
                    //     </Popover>
                    // }
                >
                    {
                        title
                    }
                </NavBar>
            </Fragment>
        )
    }
}

PublicHeader.defaultProps = {
    bgColor: '#2b85e4',
    icon: 'left',
    share: '',
    isNoIcon: false
}

PublicHeader.propTypes = {
    title: PropTypes.string,
    bgColor: PropTypes.string,
    icon: PropTypes.string,
    isNoIcon: PropTypes.bool,
}

export default PublicHeader;
